import { createContext, useContext } from "react";
import type { WarsGame } from "@playroomkit/pr-wars";
import type { WebGLRendererParameters } from 'three';

export interface RenderingOptions
{
    pixelRatio: number,
    parameters: WebGLRendererParameters;
}

const WarsContext = createContext<WarsGame | null>(null);
const RenderingOptionsContext = createContext<RenderingOptions | null>(null);

export const useManager = () => {
    const context = useContext(WarsContext);
    if(!context) {
        throw new Error("useManager must be used within a ManagerProvider");
    }

    return context;
};

export const useRenderingOptions = () => {
    const context = useContext(RenderingOptionsContext);
    if(!context) {
        throw new Error("useRenderingOptions must be used within a ManagerProvider");
    }

    return context;
}

export { WarsContext, RenderingOptionsContext }